{
  "name": " 01 coconut bomb",
  "title": "CoconutBomb",
  "description": "BombDescription",
  "stat": 1,
  "boughtEarlyStat": 0,
  "inventoryStat": 15,
  "lockFlag": 20
}